import React from 'react';
import { Route } from 'react-router';
import Active from './screens/Active/router';
import End from './screens/End/router';
import Store from './screens/Store/router';
export default (
  <Route
    path="orders"
    getComponent={(Location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./screens/Index/'));
      });
    }}
  >
    {Active}
    {End}
    {Store}
  </Route>
);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Orders/router.js
 **/